export const isTMO = !!process.env.NEXT_PUBLIC_IS_TMO
